import React from "react";
import { Grid, Box, Paper } from "@mui/material";
import GraphComponent from "../../../GraphComponent/GraphComponent";
import QuestionsAnsweredGraphExpertOverview from "../../../GraphComponent/QuestionsAnsweredGraphExpertOverview";
import styles from "./seeker.module.css";
import SeekerSearchQuestions from "./SeekerSearchQuestions";
import SeekerSearchBarComponent from "../../../GraphComponent/SeekerSearchBarComponent";
import SeekerSubmittedBarComponent from "../../../GraphComponent/SeekerSubmittedBarComponent";

export default function SeekerGraphs() {
  return (
    <div 
    className={styles.SeekerOutline}
    >
      <Grid
        container
        spacing={2}
        xs={12}
        sm={12}
        lg={12} 
        xl={12}
        md={12}
        sx={{ width: "100%", paddingTop: "15px" }}
      >
        <Grid item lg={6} xl={6} sm={12} xs={12} md={12}>
          <Paper>
            <Box>
            <SeekerSearchBarComponent type="Bar" name="Seekers by Searches" />
            </Box>
          </Paper>
        </Grid>
        <Grid item lg={6} xl={6} xs={12} md={12} sm={12}>
          <Paper>
            <SeekerSubmittedBarComponent type="Bar" name="Submitted Questions" />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}